import { render, staticRenderFns } from "./CarreraEditarForm.vue?vue&type=template&id=2669a767"
import script from "./CarreraEditarForm.vue?vue&type=script&lang=js"
export * from "./CarreraEditarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports